
import { ref } from '../../_snowpack/pkg/vue.js'

const defaultExport = {
  setup() {
    const launchLimit = ref(0)

    return { launchLimit }
  },
  methods: {
    toMissions(value) {
      localStorage.limit = limit.value
      this.$router.push({ name: 'Missions', params: { limit: value } })
    }
  }
}

import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "../../_snowpack/pkg/vue.js"

const _hoisted_1 = { class: "vh-100 vw-100 d-flex align-items-center" }
const _hoisted_2 = { class: "container d-flex flex-column justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder text-center p-5 mb-3" }, "SpaceX 🤝 GraphQL", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-muted text-center" }, [
  /*#__PURE__*/_createTextVNode(" Request and display information about past SpaceX missions from their publicly available GraphQL API. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" To start, simply enter the number of missions you want do view below. ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "currentColor",
  class: "bi bi-arrow-down-square-fill w-100 mt-5",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z" })
], -1)
const _hoisted_6 = { class: "d-md-flex d-block justify-content-center my-md-5 my-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "display-6 me-md-4 text-muted text-center" }, " Show me the last ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "display-6 ms-md-4 text-muted text-center" }, " SpaceX missions. ", -1)
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-speedometer me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 2a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 8 2zM3.732 3.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 8a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 7.31A.91.91 0 1 0 8.85 8.569l3.434-4.297a.389.389 0 0 0-.029-.518z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M6.664 15.889A8 8 0 1 1 9.336.11a8 8 0 0 1-2.672 15.78zm-4.665-4.283A11.945 11.945 0 0 1 8 10c2.186 0 4.236.585 6.001 1.606a7 7 0 1 0-12.002 0z"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Launch", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            id: "limit",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.launchLimit = $event)),
            type: "number",
            placeholder: "0",
            class: "\n              form-control form-control-lg\n              text-center\n              mx-auto mx-md-2\n              mb-md-0 mb-2\n            ",
            style: {"max-width":"80px"}
          }, null, 512), [
            [_vModelText, _ctx.launchLimit]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-success btn-lg m-3 d-flex align-items-center",
            type: "button",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.toMissions(_ctx.launchLimit)))
          }, _hoisted_12)
        ])
      ])
    ])
  ]))
};

defaultExport.render = render;

export default defaultExport;